var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Table } from '../../utils/Table';
import { DeleteIcon, EditIcon } from '../../utils/Icons';
import { TYPES } from '../../utils/FormikTextField';
import { FormikGenerator } from '../../utils/FormikGenerator';
import { Modal } from '../../utils/Modal';
import { IconButton } from '../../utils/IconButton';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import * as ServiceHabilitation from '../../services/habilitation';
import { Chip, Stack } from '@mui/material';
import { HabilitationSchema } from '../../utils/ValidationSchema';
import { CardTitle } from '../../utils/CardTitle';
export var Habilitation = function () {
    var _a = useState([]), habilitations = _a[0], setHabilitations = _a[1];
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceHabilitation.getHabilitationListe()];
                case 1:
                    data = _a.sent();
                    setHabilitations(data);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (_a, refresh) {
        var IdHabilitation = _a.IdHabilitation;
        return __awaiter(void 0, void 0, void 0, function () {
            var confirmation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ConfirmDialog({
                            title: 'Suppression',
                            content: 'Êtes-vous sûr de vouloir supprimer cette habilitation ?',
                            color: 'error',
                        })];
                    case 1:
                        confirmation = _b.sent();
                        if (!confirmation.isOk) return [3 /*break*/, 3];
                        return [4 /*yield*/, ServiceHabilitation.deleteHabilitation(IdHabilitation)];
                    case 2:
                        _b.sent();
                        refresh();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return (_jsx(_Fragment, { children: _jsx(Table, { canEdit: true, headers: [
                {
                    label: 'Habilitation',
                    assessor: 'Libelle',
                },
                {
                    label: 'Collaborateur',
                    align: 'center',
                    component: function (value) { return (_jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(Chip, { color: value.CanEditCollaborateur ? 'success' : 'error', label: "Modifier" }), _jsx(Chip, { color: value.CanExportCollaborateur ? 'success' : 'error', label: "Exporter" })] }))); },
                },
                {
                    label: 'Client',
                    align: 'center',
                    component: function (value) { return (_jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(Chip, { color: value.CanEditClient ? 'success' : 'error', label: "Modifier" }), _jsx(Chip, { color: value.CanExportClient ? 'success' : 'error', label: "Exporter" })] }))); },
                },
                {
                    label: 'Affaire',
                    align: 'center',
                    component: function (value) { return (_jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(Chip, { color: value.CanEditAffaire ? 'success' : 'error', label: "Modifier" }), _jsx(Chip, { color: value.CanExportAffaire ? 'success' : 'error', label: "Exporter" })] }))); },
                },
                {
                    label: 'Activité',
                    align: 'center',
                    component: function (value) { return (_jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(Chip, { color: value.CanEditActivite ? 'success' : 'error', label: "Modifier" }), _jsx(Chip, { color: value.CanExportActivite ? 'success' : 'error', label: "Exporter" })] }))); },
                },
                {
                    label: 'Objectif',
                    align: 'center',
                    component: function (value) { return (_jsx(Chip, { color: value.CanEditObjectif ? 'success' : 'error', label: "Modifier" })); },
                },
                {
                    label: 'Statistique',
                    align: 'center',
                    component: function (value) { return (_jsx(Chip, { color: value.CanReadStatistique ? 'success' : 'error', label: "Afficher" })); },
                },
                /*{
                  label: 'Requête',
                  align: 'center',
                  component: (value) => (
                    <Chip
                      color={value.CanReadRequete ? 'success' : 'error'}
                      label="Afficher"
                    />
                  ),
                },*/
                {
                    align: 'right',
                    component: function (value, _a) {
                        var handleUpdate = _a.handleUpdate, refresh = _a.refresh;
                        return (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ color: "primary", tooltip: "Modifier", onClick: function () { return handleUpdate(value); } }, { children: _jsx(EditIcon, {}) })), _jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer", onClick: function () { return handleDelete(value, refresh); } }, { children: _jsx(DeleteIcon, {}) }))] }));
                    },
                },
            ], datas: habilitations ? habilitations : [], renderModalEdition: function (handleClose, habilitationSelected) {
                return (_jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Habilitation" }, { children: _jsx(FormikGenerator, { validationSchema: HabilitationSchema, submitLabel: habilitationSelected.IdHabilitation
                            ? 'Enregistrer'
                            : 'Ajouter', datas: habilitationSelected, onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, ServiceHabilitation.postHabilitation(__assign(__assign({}, habilitationSelected), values))];
                                    case 1:
                                        _a.sent();
                                        handleClose();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, additionalInitialValues: Object.keys(habilitationSelected), renderContent: function (_a) {
                            var renderField = _a.renderField;
                            return (_jsxs(Stack, __assign({ className: "mt-small" }, { children: [renderField({
                                        name: 'Libelle',
                                        label: 'Habilitation',
                                        type: TYPES.TEXT,
                                        uppercaseFirstChar: true,
                                    }), _jsxs(Stack, __assign({ direction: "row", className: "mt-medium", spacing: 1 }, { children: [_jsxs(Stack, { children: [_jsx(CardTitle, { title: "Collaborateur" }), renderField({
                                                        name: 'CanEditCollaborateur',
                                                        label: 'Modifier',
                                                        type: TYPES.BOOLEAN,
                                                    }), renderField({
                                                        name: 'CanExportCollaborateur',
                                                        label: 'Exporter',
                                                        type: TYPES.BOOLEAN,
                                                    })] }), _jsxs(Stack, { children: [_jsx(CardTitle, { title: "Client" }), renderField({
                                                        name: 'CanEditClient',
                                                        label: 'Modifier',
                                                        type: TYPES.BOOLEAN,
                                                    }), renderField({
                                                        name: 'CanExportClient',
                                                        label: 'Exporter',
                                                        type: TYPES.BOOLEAN,
                                                    })] }), _jsxs(Stack, { children: [_jsx(CardTitle, { title: "Affaire" }), renderField({
                                                        name: 'CanEditAffaire',
                                                        label: 'Modifier',
                                                        type: TYPES.BOOLEAN,
                                                    }), renderField({
                                                        name: 'CanExportAffaire',
                                                        label: 'Exporter',
                                                        type: TYPES.BOOLEAN,
                                                    })] }), _jsxs(Stack, { children: [_jsx(CardTitle, { title: "Activite" }), renderField({
                                                        name: 'CanEditActivite',
                                                        label: 'Modifier',
                                                        type: TYPES.BOOLEAN,
                                                    }), renderField({
                                                        name: 'CanExportActivite',
                                                        label: 'Exporter',
                                                        type: TYPES.BOOLEAN,
                                                    })] })] })), _jsxs(Stack, __assign({ direction: "row", p: 1, spacing: 1 }, { children: [_jsxs(Stack, { children: [_jsx(CardTitle, { title: "Objectif" }), renderField({
                                                        name: 'CanEditObjectif',
                                                        label: 'Modifier',
                                                        type: TYPES.BOOLEAN,
                                                    })] }), ' ', _jsxs(Stack, { children: [_jsx(CardTitle, { title: "Statistiques" }), renderField({
                                                        name: 'CanReadStatistique',
                                                        label: 'Afficher',
                                                        type: TYPES.BOOLEAN,
                                                    })] }), ' '] }))] })));
                        }, fields: [] }) })));
            }, refresh: getData }) }));
};
//# sourceMappingURL=Habilitation.js.map